import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostStartTourCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostStartTourCommandService],
  exports: []
})
export class PostStartTourCommandServiceModule { }
